<script>
    import ContactForm from "../components/contact/ContactForm.svelte";
    import { slide } from 'svelte/transition';

    let isVisible = [false, false],
    contactInfo = '';

    const openInfo = (e) => {
        let connectionType = e.target.closest('a').getAttribute('href');

        if (connectionType === null || connectionType === '') {
            return
        }
        switch (connectionType) {
            case '#skype':
                contactInfo = 'live:gooooogr1_1';
                isVisible[0] = !isVisible[0];
                isVisible[1] = false;
                break;
            case '#email':
                contactInfo = 'admin@potatosites.com';
                isVisible[1] = !isVisible[1];
                isVisible[0] = false;
                break;
            default:
                isVisible = isVisible.map(item => item = false);
                contactInfo = '';
        } 
    };
</script>

<svelte:head>
	<title>PotatoSites | Contact</title>
</svelte:head>

<section class="container grid-lg contact">
    <div class="columns">
        <div class="column col-12">
            <h2 class="text-center text-uppercase" id="contact">Contact</h2>
            <div class="d-flex contact_icons">
                <a href="#skype" class="tooltip" data-tooltip="Get skype profile" on:click|preventDefault|trusted={ openInfo }>
                    <svg version="1.1" class="svg_icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" xml:space="preserve">
                        <circle class="fill_black" cx="100" cy="100" r="100"/>
                        <g>
                            <path class="fill_white" d="M100.5,176.5c-42.9,0-62.2-21.1-62.2-36.9c0-8.1,6-13.8,14.3-13.8c18.4,0,13.6,26.4,47.9,26.4
                                c17.6,0,27.2-9.5,27.2-19.3c0-5.9-2.9-12.4-14.5-15.2L75,108.2c-30.8-7.7-36.3-24.3-36.3-40c0-32.5,30.6-44.6,59.3-44.6
                                c26.4,0,57.6,14.6,57.6,34.1c0,8.3-7.2,13.2-15.5,13.2c-15.7,0-12.8-21.7-44.4-21.7c-15.7,0-24.4,7.1-24.4,17.3
                                c0,10.1,12.4,13.4,23.1,15.8l28.3,6.3c31,6.9,38.8,25,38.8,42C161.6,156.8,141.4,176.5,100.5,176.5z"/>
                        </g>
                    </svg>
                </a>
                <a href="#email" class="tooltip" data-tooltip="Get email" on:click|preventDefault|trusted={ openInfo }>
                    <svg version="1.1" class="svg_icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" xml:space="preserve">
                        <circle class="fill_black" cx="100" cy="100" r="100"/>
                        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
                            <path class="fill_white" d="M906.8,4849.2c-169.7-22.4-320.2-98.6-439.2-223.3c-103.2-108.4-170.8-244.5-194.6-393
                                c-7.2-44.4-8.6-153.9-2.9-202.1c27.8-229.3,161.1-430.3,362.9-548.4c75.1-43.9,162.5-74.5,256.6-90c45.3-7.5,175.4-7.5,220.7,0
                                c63.6,10.6,119.5,26.4,172.6,48.2c37.3,15.5,84,39.8,84,44.1c0,2.6-86.9,155.1-90.3,158.8c-0.6,0.6-12.6-4.9-26.4-12
                                c-121.3-61.9-263.4-76.5-395.3-40.7c-135.6,37.3-253.7,127.8-328.2,252.3c-33,55.3-59.9,131.6-69.7,198.4c-6,41.9-6,114.7,0,156.5
                                c35,239.4,225.6,430,465.5,464.7c42.7,6.3,115.5,6.3,155.1,0.3c167.7-25.8,308.2-120.7,395.6-266.6c33-55.3,59.9-131.9,69.4-197.8
                                c6-42.1,9.2-139.9,5.4-169.1c-5.2-39.3-20.4-64.2-49-81.1c-11.8-6.9-16.1-7.7-40.4-7.7c-22.9,0-29.2,1.1-39.6,6.6
                                c-15.5,8.3-33,25.8-40.4,40.1c-10.6,20.9-11.8,42.1-11.8,227.9v179.7h-61.3h-61.3l-24.4,18.3c-65.9,49.6-137,73.4-219.6,73.4
                                c-78,0-142.5-19.2-207.8-62.2c-26.1-17.2-80-71.1-97.2-97.2c-42.7-65.1-62.2-129.9-62.2-207.5c0-78,19.5-142.5,62.2-207.3
                                c17.5-26.7,71.1-80.3,96.9-97.2c44.1-29,95.2-49.6,143-58.2c54.2-9.5,128.4-4,179.4,12.9c29.8,9.7,74.2,33,98.9,51.3
                                c12.6,9.5,25.8,19.5,29.5,22.1c6.3,4.6,6.9,4.6,22.9-11.8c37.6-37.8,85.1-63.4,139-74.8c26.1-5.4,82.6-5.2,110.4,0.6
                                c82.6,16.9,149.9,70.2,188.3,148.8c26.7,54.5,28.1,62.5,29.5,171.4c1.1,103.5-1.7,139.9-15.5,202.4
                                c-66.8,301-320.2,531.5-626,569.3C1048.1,4854.4,948.1,4854.4,906.8,4849.2z M1044.1,4295.7c54.8-13.2,104.1-57.3,125.6-111.5
                                c7.7-19.8,9.2-27.5,10.3-55.9c0.9-24.9,0-37.6-3.7-51.6c-32.7-125.8-181.5-179.7-283.8-102.6c-34.1,25.8-58.5,61.6-68.8,101.2
                                c-5.4,21.8-5.4,67.1,0,88.9C848.9,4260.5,947.2,4319.2,1044.1,4295.7z"/>
                        </g>
                    </svg>
                </a>
            </div>
            
            {#if isVisible[0]}
                <div class="text-center info" transition:slide|local>
                    { contactInfo }
                </div>
            {/if}
            {#if isVisible[1]}
                <div class="text-center info" transition:slide|local>
                    { contactInfo }
                </div>
            {/if}
        </div>
        <div class="column col-8 col-md-10 col-sm-12 col-mx-auto">
            <ContactForm />
        </div>
    </div>
</section>

<style lang="scss">
    .contact_icons{
        justify-content: center;
        margin: 1.5rem 0 0.5rem 0;
        a{
            margin-left: 5px;
            margin-right: 5px;
            width: 40px;
            height: 40px;
            display: block;
            border-radius: 40px;
        }
    }
</style>